import React from "react"
import PropTypes from "prop-types"
import moment from "moment"

const formatoFecha = fecha => {
  const dia = moment(fecha, "YYYY-MM-DD")
  return dia.isValid() ? dia.format("DD/MM/YYYY") : fecha
}

const AvailabilityFilters = ({
  providers,
  providerId,
  dates,
  date,
  farms,
  farmId,
  onChangeProvider,
  onChangeDate,
  onChangeFarm,
}) => (
  // El portal del proveedor no elige proveedor: es él mismo. Sin esa columna
  // la rejilla pasa de tres a dos.
  <div className={`av-card av-filters av-anim${providers ? "" : " is-two"}`}>
    {providers && (
      <div>
        <label className="av-label" htmlFor="av-proveedor">
          Proveedor
        </label>
        <select
          id="av-proveedor"
          className="av-field"
          value={providerId || ""}
          onChange={event => onChangeProvider(Number(event.target.value))}
        >
          {providers.length === 0 && <option value="">Sin proveedores</option>}
          {providers.map(provider => (
            <option key={provider.id} value={provider.id}>
              {provider.company_name}
            </option>
          ))}
        </select>
      </div>
    )}

    <div>
      <label className="av-label" htmlFor="av-fecha">
        Fecha
      </label>
      <select
        id="av-fecha"
        className="av-field"
        value={date || ""}
        onChange={event => onChangeDate(event.target.value)}
      >
        {dates.length === 0 && <option value="">Sin fechas</option>}
        {dates.map(item => (
          <option key={item} value={item}>
            {formatoFecha(item)}
          </option>
        ))}
      </select>
    </div>

    <div>
      <label className="av-label" htmlFor="av-sucursal">
        Sucursal
      </label>
      <select
        id="av-sucursal"
        className="av-field"
        value={farmId || ""}
        onChange={event => onChangeFarm(Number(event.target.value))}
      >
        {farms.length === 0 && <option value="">Sin sucursales</option>}
        {farms.map(farm => (
          <option key={farm.id} value={farm.id}>
            {farm.name}
          </option>
        ))}
      </select>
    </div>
  </div>
)

AvailabilityFilters.propTypes = {
  // ausente en el portal del proveedor
  providers: PropTypes.array,
  providerId: PropTypes.number,
  dates: PropTypes.array.isRequired,
  date: PropTypes.string,
  farms: PropTypes.array.isRequired,
  farmId: PropTypes.number,
  onChangeProvider: PropTypes.func,
  onChangeDate: PropTypes.func.isRequired,
  onChangeFarm: PropTypes.func.isRequired,
}

export default AvailabilityFilters
